module.exports = __webpack_public_path__ + "img/T1C_xs_003.0a1477c3.png";